/**
 * sequence.
 * returns sequential numbers per named sequence globally
 *
 * @copyright Realeyes OU. All rights reserved.
 */

const sequences = {};

const sequenceGenerator = {
    /**
     * return next integer for named/global sequence of numbers
     * @param {string} sequenceName name of the sequence
     * @returns {int}
     */
    next(sequenceName = 'Global') {
        if (typeof sequences[sequenceName] !== 'undefined') {
            sequences[sequenceName] += 1;
        } else {
            sequences[sequenceName] = 0;
        }

        return sequences[sequenceName];
    },
    /**
     * resets named/global sequence to 0
     * @param {string} sequenceName name of the sequence
     * @return {void}
     */
    reset(sequenceName = 'Global') {
        delete sequences[sequenceName];
    },
};

export default sequenceGenerator;
